let mobx = require('mobx');
// create State object
let data = {
    order: {},
}
let orderEvaluate = mobx.observable(data);

// export default loginState;
module.exports = orderEvaluate;